import { render, staticRenderFns } from "./printer-queues.vue?vue&type=template&id=118771d7"
import script from "./printer-queues.vue?vue&type=script&lang=js"
export * from "./printer-queues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports